import styled from "styled-components";
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const HeaderNavbarLeftContainerDefaultBox = styled.div`
  display: flex;
  margin: 0 auto 0 0;
  align-items: center;
  ${CssRule.For.RTL.build()} & {
    margin: 0 0 0 auto;
  }
`;
